import React from 'react';
import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import StatusPanel from './components/StatusPanel';
import { LabelColored, H2, LinkedItem } from '../../layout/theme/components';
import ArrowIcon from '../../shared/components/ArrowIcon';

import StatusFooter from './components/StatusFooter';
import Container from '../../shared/components/Container';

const Headers = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 0.7em;
  margin-bottom: 2%;
`;
const PanelsBox = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 6%;
`;
const StyledLabelColored = styled(LabelColored)`
  margin-bottom: 5%;
  word-break: break-word;
`;
const VerificationBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: baseline;
  flex-wrap: no-wrap;
`;
const VerificationLabel = styled(LabelColored)`
  color: #fabb4a;
`;

const CommnityStatusComponent = ({
  keepers,
  name,
  residentsNumber,
  residentsPercent,
  levelStatuses,
  keeperExists,
  isRegularUser
}) => (
  <Container noBotttomPadding>
    <Link to="/">
      <ArrowIcon />
    </Link>
    <Headers>
      <LabelColored>Wspólnota</LabelColored>
      <H2>{name}</H2>
    </Headers>
    {keepers.length > 0 ? (
      <StyledLabelColored bold>Zarządca: {keepers}</StyledLabelColored>
    ) : !keeperExists ? (
      <Link to="/zarzadca">
        <LinkedItem>Dodaj Zarządcę +</LinkedItem>
      </Link>
    ) : (
      <VerificationBox>
        <StyledLabelColored bold>Zarządca:&nbsp;</StyledLabelColored>
        <VerificationLabel bold>Weryfikacja</VerificationLabel>
      </VerificationBox>
    )}
    <PanelsBox>
      <StatusPanel level="basic" status={levelStatuses['basic']} />
      <StatusPanel level="premium" premium status={levelStatuses['premium']} />
    </PanelsBox>
    <StatusFooter
      residentsNumber={residentsNumber}
      residentsPercent={residentsPercent}
      isRegularUser={isRegularUser}
    />
  </Container>
);

CommnityStatusComponent.propTypes = {
  name: PropTypes.string.isRequired,
  keepers: PropTypes.string.isRequired,
  residentsNumber: PropTypes.number.isRequired,
  residentsPercent: PropTypes.number.isRequired,
  levelStatuses: PropTypes.object,
  keeperExists: PropTypes.bool,
  isRegularUser: PropTypes.bool
};

CommnityStatusComponent.defaultProps = {
  residentsPercent: null,
  keeperExists: false,
  isRegularUser: false
};

export default CommnityStatusComponent;
